import type { PlatformOSType } from 'react-native/Libraries/Utilities/Platform';

export default class Platform {
  static OS: 'web';

  static select<T>(
    specifics:
      | ({ [platform in PlatformOSType]?: T } & { default: T })
      | { [platform in PlatformOSType]: T },
  ): T | undefined {
    return 'default' in specifics ? specifics.default : undefined;
  }
}
